import { render } from "./FantasyGame.vue?vue&type=template&id=e7bee03c"
const script = {}

import "./FantasyGame.vue?vue&type=style&index=0&id=e7bee03c&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__